<template>
    <div class="container-launch-card">
        <div class="container-launch-card-text">
            <div class="beta">Beta</div>
            <div class="title">Gestão para Lançamentos Imobiliários</div>
            <div class="subtitle">
                Encontramos {{ data.length }}
                {{ data.length > 1 ? 'lançamentos cadastrados' : 'lançamento cadastrado' }}
            </div>
        </div>

        <div class="container-launch-card-component">
            <card v-for="(launch, index) in data" :key="index" :data="launch" />

            <div class="container-launch-card-component-button">
                <div class="button">
                    <ui-button design="md primary-alt" @click="createLaunch">
                        <i class="fal fa-plus" />
                    </ui-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	import { uiButton } from '@/components/ui/buttons'
	import { mapActions } from 'vuex'
	
	import {  defaultMenuList, defaultForm } from '../data.js'


	import card from '../card'

	export default {
		name: 'ui-list-launch-card',

		components: {
			card,
			uiButton
		},

		props: {
			data: {
				type: Array,
				required: true
			}
		},

		data() {
			return {
				steps: [...defaultMenuList()],
				config: { ...defaultForm() }
			}
		},

		methods: {
			...mapActions('launchDay', ['setConfig', 'setSteps']),
			/**
			 * Redireciona para a tela de criação de um lançamento
			 */
			createLaunch() {
				this.setConfig(this.config)
				this.setSteps(this.steps)
				this.$router.push({ name: 'launch.management.create.mainData' })
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>